import { Box, Typography, Skeleton } from "@mui/material";
import { useTranslation } from "react-i18next";
import { styles } from "./styles";
import CountriesMap from "./CountriesMap";

const CountriesCareerLoader = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "overview" });

  return (
    <Box sx={styles.container}>
      <Typography sx={styles.title}>{t("countriesCareer")}</Typography>
      <Box sx={styles.contentWrapper}>
        <CountriesMap countries={[]} />
        <Box sx={styles.countriesList}>
          {[...Array(5)].map((_, idx) => (
            <Box key={idx} sx={styles.countryItemLoader}>
              <Skeleton variant="rounded" width={20} height={16} sx={styles.flagSkeleton} />
              <Skeleton variant="text" width={120} height={20} sx={styles.countrySkeleton} />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default CountriesCareerLoader;
